import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export interface IArchiveContractorDeductionTemplateRequest {
  companyID: string;
  deductionTemplateID: string;
}

export const archiveContractorDeductionTemplate = (axios: IAxiosInstance) => {
  return async (
    params: IArchiveContractorDeductionTemplateRequest
  ): Promise<void> => {
    const { deductionTemplateID, ...body } = params;
    const response = await axios.noRetry.delete<IApiResponse<null>>(
      `/api/contractor-deduction-templates/${deductionTemplateID}`,
      {
        data: body,
      }
    );
    const data = response.data;

    if (data.success) {
      return;
    }

    throw new Error("Failed to archive contractor deduction template");
  };
};
